// ABOUTME: Hook for a controlled "..." dropdown that also opens on right-click.
// ABOUTME: Returns flags and handlers the caller wires into the container div
// ABOUTME: and the CDropdown, plus an `isRightClick` flag for highlight CSS.

import { useCallback, useState } from "react"
import type { MouseEvent } from "react"

export interface UseRightClickMenuResult {
  /** Current dropdown open state. Pass to CDropdown `open`. */
  isOpen: boolean
  /** True only while the menu is open AND was opened via right-click.
   *  Use it to apply a highlight style (e.g. `drop-zone-over`) so the user
   *  sees which element the menu targets — unnecessary when they clicked
   *  the visible "..." trigger themselves. */
  isRightClick: boolean
  /** Pass to CDropdown `onOpenChange`. */
  onOpenChange: (next: boolean) => void
  /** Attach to the container's `onContextMenu` to open the menu on right-click. */
  openViaRightClick: (e: MouseEvent) => void
}

export const useRightClickMenu = (): UseRightClickMenuResult => {
  const [isOpen, setIsOpen] = useState(false)
  const [isRightClick, setIsRightClick] = useState(false)

  const onOpenChange = useCallback((next: boolean) => {
    setIsOpen(next)
    if (!next) setIsRightClick(false)
  }, [])

  const openViaRightClick = useCallback((e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setIsRightClick(true)
    setIsOpen(true)
  }, [])

  return { isOpen, isRightClick, onOpenChange, openViaRightClick }
}
